/**
 * Custom cursor feature
 */

import throttle from '../../util/throttle';

document.querySelectorAll('.custom-cursor-container')?.forEach((wrap) => {
	wrap.classList.add('active');
	const cursor = wrap.querySelector('.custom-cursor');
	wrap.addEventListener(
		'mousemove',
		throttle((e) => {
			cursor.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
		}, 50)
	);
});
